// Cross Jobs plans (AUD, ex GST). Limits must match backend billing.PLANS. Data lives in plans.json (also read by scripts/prerender.js).
import PLAN_DATA from "./plans.json";

export const PLANS = PLAN_DATA;
export const planInfo = (id) => PLANS.find((p) => p.id === id);
export const money = (n) => `$${n.toLocaleString("en-AU", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
export const centsMoney = (c) => money(Math.round(c) / 100);
export const fmtDay = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "");

// Opens the plan & billing dialog from anywhere (optionally explaining why, e.g. a plan limit).
export const openBilling = (reason = "") => window.dispatchEvent(new CustomEvent("cj-open-billing", { detail: { reason } }));
